"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessHighchartsSettingsStickinessTableComponent = void 0;
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const StickinessTableModal_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessTableModal");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const StickinessHighchartsSettingsStickinessTableComponent = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const [visible, setVisible] = (0, react_1.useState)(false);
    const onStickinessTableModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setVisible(false);
        }
    }, [isMounted]);
    const onClickOpenTable = (0, react_1.useCallback)(() => {
        setVisible(true);
    }, []);
    const title = (0, react_1.useMemo)(() => {
        return props.lineType === LineTypeJSONModel_1.LineType.cumulative ? "Cumulative Stickiness Table" : "Non-Cumulative Stickiness Table";
    }, [props.lineType]);
    return React.createElement(React.Fragment, null,
        React.createElement(StickinessTableModal_1.StickinessTableModal, { visible: visible, title: title, onDestroy: onStickinessTableModalDestroy, lineType: props.lineType }),
        React.createElement(antd_1.Button, { type: "default", icon: React.createElement(icons_1.TableOutlined, null), disabled: props.disabled, onClick: onClickOpenTable }));
};
exports.StickinessHighchartsSettingsStickinessTableComponent = StickinessHighchartsSettingsStickinessTableComponent;
